import { Dropdown } from './dropdown';
import { Container, Label, ProName, Extended } from './styles';
import { DateTime } from 'luxon'


const Iterable = ({
  project = {},
  setFlowList,
  onSelect,
  selected,
  openFlow,
  setOpenFlow,
}) => {
  const allFlows = [project.main, ...project.versions];

  //Renderizado via map

  const formattedDate = DateTime.fromISO(project.main.createdAt, { zone: 'utc' })
    .toLocaleString(DateTime.DATE_FULL)

  return (
    <Container
      onClick={() => {
        setOpenFlow(project.main._id);

        const fromProject = allFlows.find((item) => item._id === selected._id);
        if (!fromProject) {

          if (project.default) {
            const defaultProject = allFlows.find(item => item._id === project.default)
            onSelect(defaultProject)

          } else {
            onSelect(project.main)
          }

        };
      }}
      Open={openFlow === project.main._id}
    >
      <ProName>{project.main.title}</ProName>
      <Label>Criado em: {formattedDate}</Label>

      {openFlow === project.main._id ? (
        <Extended>
          <span>Versão</span>
          <Dropdown
            setFlowList={setFlowList}
            flows={allFlows}
            defaultVersion={project.default}
            onSelect={onSelect}
            selected={selected}
          />
        </Extended>
      ) : (
        ''
      )}
    </Container>
  );
};

export default Iterable;
